import { render, staticRenderFns } from "./StandardSampleRow.vue?vue&type=template&id=4c6cdc81&scoped=true&"
import script from "./StandardSampleRow.vue?vue&type=script&lang=js&"
export * from "./StandardSampleRow.vue?vue&type=script&lang=js&"
import style0 from "./StandardSampleRow.vue?vue&type=style&index=0&id=4c6cdc81&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6cdc81",
  null
  
)

export default component.exports